var _filter, _rect, _g, _text, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _circle, _circle2, _g9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 350",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stackBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#020617"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f172a"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "techGlow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 4,
    floodColor: "#000",
    floodOpacity: 0.3
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 350,
    fill: "url(#stackBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1e293b",
    strokeWidth: 0.5,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 87.5,
    x2: 700,
    y2: 87.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 175,
    x2: 700,
    y2: 175
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 262.5,
    x2: 700,
    y2: 262.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 175,
    y1: 0,
    x2: 175,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 0,
    x2: 350,
    y2: 350
  }), /*#__PURE__*/React.createElement("line", {
    x1: 525,
    y1: 0,
    x2: 525,
    y2: 350
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 35,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "system-ui",
    fontSize: 20,
    fontWeight: "bold"
  }, "Technology Stack")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 120)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -40,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#1e3a5f",
    stroke: "#336791",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: -8,
    rx: 22,
    ry: 10,
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22,-8 L-22,12 Q-22,22 0,22 Q22,22 22,12 L22,-8",
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 12,
    rx: 22,
    ry: 10,
    fill: "none",
    stroke: "#60a5fa",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 600
  }, "PostgreSQL"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Database"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(250, 120)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -40,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#422006",
    stroke: "#f97316",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12,18 L0,-22 L6,2 L18,18 L0,25 Z",
    fill: "none",
    stroke: "#fb923c",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8,8 L18,18",
    fill: "none",
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    textAnchor: "middle",
    fill: "#fdba74",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 600
  }, "Firebase"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Analytics"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 250)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -40,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#1e1b4b",
    stroke: "#6366f1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 0,
    r: 12,
    fill: "none",
    stroke: "#818cf8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 0,
    r: 12,
    fill: "none",
    stroke: "#818cf8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: 0,
    x2: 3,
    y2: 0,
    stroke: "#a5b4fc",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    textAnchor: "middle",
    fill: "#a5b4fc",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 600
  }, "MCP"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Protocol"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 185)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -65,
    y: -55,
    width: 130,
    height: 110,
    rx: 12,
    fill: "#2e1065",
    stroke: "#a855f7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 32,
    ry: 25,
    fill: "none",
    stroke: "#c084fc",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -10,
    cy: -8,
    r: 5,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: -10,
    r: 4,
    fill: "#c084fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 8,
    r: 6,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 8,
    r: 3,
    fill: "#c084fc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 6,
    r: 4,
    fill: "#a855f7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: -8,
    x2: 10,
    y2: -10,
    stroke: "#e9d5ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: -8,
    x2: 0,
    y2: 8,
    stroke: "#e9d5ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: -10,
    x2: 0,
    y2: 8,
    stroke: "#e9d5ff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 55,
    textAnchor: "middle",
    fill: "#e9d5ff",
    fontFamily: "system-ui",
    fontSize: 13,
    fontWeight: "bold"
  }, "LLM"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 72,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "system-ui",
    fontSize: 9
  }, "AI Processing"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 120)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -40,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#064e3b",
    stroke: "#10b981",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -15,
    width: 40,
    height: 30,
    rx: 3,
    fill: "none",
    stroke: "#34d399",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -8,
    x2: 15,
    y2: -8,
    stroke: "#6ee7b7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15,
    y1: -2,
    x2: 5,
    y2: -2,
    stroke: "#6ee7b7",
    strokeWidth: 1.5,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#10b981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#34d399"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 3,
    width: 8,
    height: 8,
    rx: 1,
    fill: "#6ee7b7"
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 600
  }, "Generative UI"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 9
  }, "thesys.dev"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 250)",
    filter: "url(#techGlow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -40,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#1c1917",
    stroke: "#78716c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, -5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -18,
    y: -18,
    width: 36,
    height: 36,
    rx: 4,
    fill: "none",
    stroke: "#a8a29e",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: -10,
    x2: 12,
    y2: -10,
    stroke: "#d6d3d1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: -2,
    x2: 8,
    y2: -2,
    stroke: "#d6d3d1",
    strokeWidth: 1.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: 6,
    x2: 10,
    y2: 6,
    stroke: "#d6d3d1",
    strokeWidth: 1.5,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12,
    y1: 14,
    x2: 4,
    y2: 14,
    stroke: "#d6d3d1",
    strokeWidth: 1.5,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    textAnchor: "middle",
    fill: "#d6d3d1",
    fontFamily: "system-ui",
    fontSize: 11,
    fontWeight: 600
  }, "Reports"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 65,
    textAnchor: "middle",
    fill: "#64748b",
    fontFamily: "system-ui",
    fontSize: 9
  }, "Human-Readable"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#475569",
    strokeWidth: 1.5,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100,160 L100,200",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,160 Q320,185 295,185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,250 L275,210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,120 L275,165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,155 L485,130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,220 L485,250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550,170 L550,200"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    fill: "#a855f7"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "3s",
    repeatCount: "indefinite",
    path: "M100,160 L100,200 L200,230 L280,200"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    fill: "#10b981"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2.5s",
    repeatCount: "indefinite",
    path: "M425,185 L500,185 L550,200 L550,210"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "system-ui",
    fontSize: 9,
    fill: "#475569"
  }, /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 320,
    textAnchor: "middle"
  }, "Data Layer"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 320,
    textAnchor: "middle"
  }, "Processing"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 320,
    textAnchor: "middle"
  }, "Presentation"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechStack);
export default __webpack_public_path__ + "static/media/tech-stack.93d48e618958ff8dee7edc9f6866e1c1.svg";
export { ForwardRef as ReactComponent };